<template>
  <div>
    <h3 class="section_title text-capitalize">
      {{ sectionName }}
    </h3>
  </div>
</template>

<script>
export default {
  name: "SectionTitle",
  props: {
    sectionName: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.section_title {
  font-weight: bold;
  margin-bottom: 2rem;
  position: relative;
  width: fit-content;
  color: $title_color;
  &::before {
    // position: absolute;
    // left: 0;
    // bottom: -8px;
    // content: "";
    // height: 3px;
    // width: 50%;
    // background-color: $main_color;
  }
}
</style>
